import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
  _excluded2 = ["mainAxis", "crossAxis", "limiter"];
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import _regeneratorRuntime from "/opt/build/repo/gatsby/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var Ie = Object.create;
var he = Object.defineProperty;
var $e = Object.getOwnPropertyDescriptor;
var ze = Object.getOwnPropertyNames;
var je = Object.getPrototypeOf,
  Xe = Object.prototype.hasOwnProperty;
var Ue = function Ue(t, e) {
  return function () {
    return e || t((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};
var Ye = function Ye(t, e, n, o) {
  if (e && typeof e == "object" || typeof e == "function") {
    var _iterator = _createForOfIteratorHelper(ze(e)),
      _step;
    try {
      var _loop = function _loop() {
        var l = _step.value;
        !Xe.call(t, l) && l !== n && he(t, l, {
          get: function get() {
            return e[l];
          },
          enumerable: !(o = $e(e, l)) || o.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return t;
};
var ye = function ye(t, e, n) {
  return n = t != null ? Ie(je(t)) : {}, Ye(e || !t || !t.__esModule ? he(n, "default", {
    value: t,
    enumerable: !0
  }) : n, t);
};
var Gt = Ue(function (ko, Ft) {
  (function () {
    "use strict";

    var t = {}.hasOwnProperty,
      e = "[native code]";
    function n() {
      for (var o = [], l = 0; l < arguments.length; l++) {
        var r = arguments[l];
        if (r) {
          var i = typeof r;
          if (i === "string" || i === "number") o.push(r);else if (Array.isArray(r)) {
            if (r.length) {
              var s = n.apply(null, r);
              s && o.push(s);
            }
          } else if (i === "object") {
            if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]")) {
              o.push(r.toString());
              continue;
            }
            for (var a in r) {
              t.call(r, a) && r[a] && o.push(a);
            }
          }
        }
      }
      return o.join(" ");
    }
    typeof Ft < "u" && Ft.exports ? (n.default = n, Ft.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function () {
      return n;
    }) : window.classNames = n;
  })();
});
import { useEffect as Ut, useState as $ } from "react";
var de = ye(Gt());
import { useEffect as Z, useState as xt, useRef as st } from "react";
var Je = function Je(t, e, n) {
    var o = null;
    return function () {
      var _this = this;
      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }
      var i = function i() {
        o = null, n || t.apply(_this, r);
      };
      o && clearTimeout(o), o = setTimeout(i, e);
    };
  },
  Qt = Je;
import { jsx as Qe } from "react/jsx-runtime";
var Ge = function Ge(_ref) {
    var t = _ref.content;
    return Qe("span", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  },
  Zt = Ge;
import { createContext as Ze, useCallback as to, useContext as eo, useMemo as oo, useState as ge } from "react";
import { jsx as lo } from "react/jsx-runtime";
var Kt = "DEFAULT_TOOLTIP_ID",
  no = {
    anchorRefs: new Set(),
    activeAnchor: {
      current: null
    },
    attach: function attach() {},
    detach: function detach() {},
    setActiveAnchor: function setActiveAnchor() {}
  },
  ro = {
    getTooltipData: function getTooltipData() {
      return no;
    }
  },
  we = Ze(ro),
  io = function io(_ref2) {
    var t = _ref2.children;
    var _ge = ge(_defineProperty({}, Kt, new Set())),
      _ge2 = _slicedToArray(_ge, 2),
      e = _ge2[0],
      n = _ge2[1],
      _ge3 = ge(_defineProperty({}, Kt, {
        current: null
      })),
      _ge4 = _slicedToArray(_ge3, 2),
      o = _ge4[0],
      l = _ge4[1],
      r = function r(f) {
        for (var _len2 = arguments.length, c = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          c[_key2 - 1] = arguments[_key2];
        }
        n(function (d) {
          var y;
          var p = (y = d[f]) != null ? y : new Set();
          return c.forEach(function (g) {
            return p.add(g);
          }), _objectSpread(_objectSpread({}, d), {}, _defineProperty({}, f, new Set(p)));
        });
      },
      i = function i(f) {
        for (var _len3 = arguments.length, c = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          c[_key3 - 1] = arguments[_key3];
        }
        n(function (d) {
          var p = d[f];
          return p ? (c.forEach(function (y) {
            return p.delete(y);
          }), _objectSpread({}, d)) : d;
        });
      },
      s = function s(f, c) {
        l(function (d) {
          var p;
          return ((p = d[f]) == null ? void 0 : p.current) === c.current ? d : _objectSpread(_objectSpread({}, d), {}, _defineProperty({}, f, c));
        });
      },
      a = to(function () {
        var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Kt;
        var c, d;
        return {
          anchorRefs: (c = e[f]) != null ? c : new Set(),
          activeAnchor: (d = o[f]) != null ? d : {
            current: null
          },
          attach: function attach() {
            for (var _len4 = arguments.length, p = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              p[_key4] = arguments[_key4];
            }
            return r.apply(void 0, [f].concat(p));
          },
          detach: function detach() {
            for (var _len5 = arguments.length, p = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              p[_key5] = arguments[_key5];
            }
            return i.apply(void 0, [f].concat(p));
          },
          setActiveAnchor: function setActiveAnchor(p) {
            return s(f, p);
          }
        };
      }, [e, o, r, i]),
      u = oo(function () {
        return {
          getTooltipData: a
        };
      }, [a]);
    return lo(we.Provider, {
      value: u,
      children: t
    });
  };
function pt() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Kt;
  return eo(we).getTooltipData(t);
}
var Te = io;
var xe = ye(Gt());
import { useEffect as so, useRef as co } from "react";
import { jsx as fo } from "react/jsx-runtime";
var ao = function ao(_ref3) {
    var t = _ref3.tooltipId,
      e = _ref3.children,
      n = _ref3.className,
      o = _ref3.place,
      l = _ref3.content,
      r = _ref3.html,
      i = _ref3.variant,
      s = _ref3.offset,
      a = _ref3.wrapper,
      u = _ref3.events,
      f = _ref3.positionStrategy,
      c = _ref3.delayShow,
      d = _ref3.delayHide;
    var _pt = pt(t),
      p = _pt.attach,
      y = _pt.detach,
      g = co(null);
    return so(function () {
      return p(g), function () {
        y(g);
      };
    }, []), fo("span", {
      ref: g,
      className: (0, xe.default)("react-tooltip-wrapper", n),
      "data-tooltip-place": o,
      "data-tooltip-content": l,
      "data-tooltip-html": r,
      "data-tooltip-variant": i,
      "data-tooltip-offset": s,
      "data-tooltip-wrapper": a,
      "data-tooltip-events": u,
      "data-tooltip-position-strategy": f,
      "data-tooltip-delay-show": c,
      "data-tooltip-delay-hide": d,
      children: e
    });
  },
  ve = ao;
import { useLayoutEffect as uo, useEffect as po } from "react";
var mo = typeof window != "undefined" ? uo : po,
  be = mo;
function _t(t) {
  return t.split("-")[1];
}
function oe(t) {
  return t === "y" ? "height" : "width";
}
function dt(t) {
  return t.split("-")[0];
}
function St(t) {
  return ["top", "bottom"].includes(dt(t)) ? "x" : "y";
}
function Ee(t, e, n) {
  var o = t.reference,
    l = t.floating,
    r = o.x + o.width / 2 - l.width / 2,
    i = o.y + o.height / 2 - l.height / 2,
    s = St(e),
    a = oe(s),
    u = o[a] / 2 - l[a] / 2,
    f = s === "x",
    c;
  switch (dt(e)) {
    case "top":
      c = {
        x: r,
        y: o.y - l.height
      };
      break;
    case "bottom":
      c = {
        x: r,
        y: o.y + o.height
      };
      break;
    case "right":
      c = {
        x: o.x + o.width,
        y: i
      };
      break;
    case "left":
      c = {
        x: o.x - l.width,
        y: i
      };
      break;
    default:
      c = {
        x: o.x,
        y: o.y
      };
  }
  switch (_t(e)) {
    case "start":
      c[s] -= u * (n && f ? -1 : 1);
      break;
    case "end":
      c[s] += u * (n && f ? -1 : 1);
  }
  return c;
}
var Ae = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e, n) {
    var _n$placement, o, _n$strategy, l, _n$middleware, r, i, s, a, u, _Ee, f, c, d, p, y, g, _Ee2, _s$g, w, T, _yield$T, x, b, _, R;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _n$placement = n.placement;
            o = _n$placement === void 0 ? "bottom" : _n$placement;
            _n$strategy = n.strategy;
            l = _n$strategy === void 0 ? "absolute" : _n$strategy;
            _n$middleware = n.middleware;
            r = _n$middleware === void 0 ? [] : _n$middleware;
            i = n.platform;
            s = r.filter(Boolean);
            _context.next = 10;
            return i.isRTL == null ? void 0 : i.isRTL(e);
          case 10:
            a = _context.sent;
            _context.next = 13;
            return i.getElementRects({
              reference: t,
              floating: e,
              strategy: l
            });
          case 13:
            u = _context.sent;
            _Ee = Ee(u, o, a);
            f = _Ee.x;
            c = _Ee.y;
            d = o;
            p = {};
            y = 0;
            g = 0;
          case 21:
            if (!(g < s.length)) {
              _context.next = 56;
              break;
            }
            _s$g = s[g];
            w = _s$g.name;
            T = _s$g.fn;
            _context.next = 27;
            return T({
              x: f,
              y: c,
              initialPlacement: o,
              placement: d,
              strategy: l,
              middlewareData: p,
              rects: u,
              platform: i,
              elements: {
                reference: t,
                floating: e
              }
            });
          case 27:
            _yield$T = _context.sent;
            x = _yield$T.x;
            b = _yield$T.y;
            _ = _yield$T.data;
            R = _yield$T.reset;
            f = x !== null && x !== void 0 ? x : f;
            c = b !== null && b !== void 0 ? b : c;
            p = _objectSpread(_objectSpread({}, p), {}, _defineProperty({}, w, _objectSpread(_objectSpread({}, p[w]), _)));
            _context.t0 = R && y <= 50;
            if (!_context.t0) {
              _context.next = 53;
              break;
            }
            y++;
            _context.t1 = typeof R == "object";
            if (!_context.t1) {
              _context.next = 52;
              break;
            }
            R.placement && (d = R.placement);
            _context.t2 = R.rects;
            if (!_context.t2) {
              _context.next = 51;
              break;
            }
            if (!(R.rects === !0)) {
              _context.next = 49;
              break;
            }
            _context.next = 46;
            return i.getElementRects({
              reference: t,
              floating: e,
              strategy: l
            });
          case 46:
            _context.t3 = _context.sent;
            _context.next = 50;
            break;
          case 49:
            _context.t3 = R.rects;
          case 50:
            u = _context.t3;
          case 51:
            _Ee2 = Ee(u, d, a), f = _Ee2.x, c = _Ee2.y;
          case 52:
            g = -1;
          case 53:
            g++;
            _context.next = 21;
            break;
          case 56:
            return _context.abrupt("return", {
              x: f,
              y: c,
              placement: d,
              strategy: l,
              middlewareData: p
            });
          case 57:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function Ae(_x, _x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();
function Le(t) {
  return typeof t != "number" ? function (e) {
    return _objectSpread({
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, e);
  }(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Rt(t) {
  return _objectSpread(_objectSpread({}, t), {}, {
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function ne(_x4, _x5) {
  return _ne.apply(this, arguments);
}
function _ne() {
  _ne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(t, e) {
    var n, o, l, r, i, s, a, _e2, _e2$boundary, u, _e2$rootBoundary, f, _e2$elementContext, c, _e2$altBoundary, d, _e2$padding, p, y, g, w, T, x, b, _;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            e === void 0 && (e = {});
            o = t.x;
            l = t.y;
            r = t.platform;
            i = t.rects;
            s = t.elements;
            a = t.strategy;
            _e2 = e;
            _e2$boundary = _e2.boundary;
            u = _e2$boundary === void 0 ? "clippingAncestors" : _e2$boundary;
            _e2$rootBoundary = _e2.rootBoundary;
            f = _e2$rootBoundary === void 0 ? "viewport" : _e2$rootBoundary;
            _e2$elementContext = _e2.elementContext;
            c = _e2$elementContext === void 0 ? "floating" : _e2$elementContext;
            _e2$altBoundary = _e2.altBoundary;
            d = _e2$altBoundary === void 0 ? !1 : _e2$altBoundary;
            _e2$padding = _e2.padding;
            p = _e2$padding === void 0 ? 0 : _e2$padding;
            y = Le(p);
            g = s[d ? c === "floating" ? "reference" : "floating" : c];
            _context9.t0 = Rt;
            _context9.t1 = r;
            _context9.next = 24;
            return r.isElement == null ? void 0 : r.isElement(g);
          case 24:
            _context9.t3 = n = _context9.sent;
            _context9.t2 = _context9.t3 == null;
            if (_context9.t2) {
              _context9.next = 28;
              break;
            }
            _context9.t2 = n;
          case 28:
            if (!_context9.t2) {
              _context9.next = 32;
              break;
            }
            _context9.t4 = g;
            _context9.next = 38;
            break;
          case 32:
            _context9.t5 = g.contextElement;
            if (_context9.t5) {
              _context9.next = 37;
              break;
            }
            _context9.next = 36;
            return r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating);
          case 36:
            _context9.t5 = _context9.sent;
          case 37:
            _context9.t4 = _context9.t5;
          case 38:
            _context9.t6 = _context9.t4;
            _context9.t7 = u;
            _context9.t8 = f;
            _context9.t9 = a;
            _context9.t10 = {
              element: _context9.t6,
              boundary: _context9.t7,
              rootBoundary: _context9.t8,
              strategy: _context9.t9
            };
            _context9.next = 45;
            return _context9.t1.getClippingRect.call(_context9.t1, _context9.t10);
          case 45:
            _context9.t11 = _context9.sent;
            w = (0, _context9.t0)(_context9.t11);
            T = c === "floating" ? _objectSpread(_objectSpread({}, i.floating), {}, {
              x: o,
              y: l
            }) : i.reference;
            _context9.next = 50;
            return r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating);
          case 50:
            x = _context9.sent;
            _context9.next = 53;
            return r.isElement == null ? void 0 : r.isElement(x);
          case 53:
            _context9.t13 = _context9.sent;
            if (!_context9.t13) {
              _context9.next = 58;
              break;
            }
            _context9.next = 57;
            return r.getScale == null ? void 0 : r.getScale(x);
          case 57:
            _context9.t13 = _context9.sent;
          case 58:
            _context9.t12 = _context9.t13;
            if (_context9.t12) {
              _context9.next = 61;
              break;
            }
            _context9.t12 = {
              x: 1,
              y: 1
            };
          case 61:
            b = _context9.t12;
            _context9.t14 = Rt;
            if (!r.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context9.next = 69;
              break;
            }
            _context9.next = 66;
            return r.convertOffsetParentRelativeRectToViewportRelativeRect({
              rect: T,
              offsetParent: x,
              strategy: a
            });
          case 66:
            _context9.t15 = _context9.sent;
            _context9.next = 70;
            break;
          case 69:
            _context9.t15 = T;
          case 70:
            _context9.t16 = _context9.t15;
            _ = (0, _context9.t14)(_context9.t16);
            return _context9.abrupt("return", {
              top: (w.top - _.top + y.top) / b.y,
              bottom: (_.bottom - w.bottom + y.bottom) / b.y,
              left: (w.left - _.left + y.left) / b.x,
              right: (_.right - w.right + y.right) / b.x
            });
          case 73:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _ne.apply(this, arguments);
}
var ho = Math.min,
  yo = Math.max;
function ee(t, e, n) {
  return yo(t, ho(e, n));
}
var re = function re(t) {
    return {
      name: "arrow",
      options: t,
      fn: function fn(e) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _data, _ref6;
          var _ref5, n, _ref5$padding, o, l, r, i, s, a, u, f, c, d, p, y, g, w, T, x, b, _, R, O, q, W, N, M, v, P;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _ref5 = t || {}, n = _ref5.element, _ref5$padding = _ref5.padding, o = _ref5$padding === void 0 ? 0 : _ref5$padding, l = e.x, r = e.y, i = e.placement, s = e.rects, a = e.platform, u = e.elements;
                  if (!(n == null)) {
                    _context2.next = 3;
                    break;
                  }
                  return _context2.abrupt("return", {});
                case 3:
                  f = Le(o);
                  c = {
                    x: l,
                    y: r
                  };
                  d = St(i);
                  p = oe(d);
                  _context2.next = 9;
                  return a.getDimensions(n);
                case 9:
                  y = _context2.sent;
                  g = d === "y";
                  w = g ? "top" : "left";
                  T = g ? "bottom" : "right";
                  x = g ? "clientHeight" : "clientWidth";
                  b = s.reference[p] + s.reference[d] - c[d] - s.floating[p];
                  _ = c[d] - s.reference[d];
                  _context2.next = 18;
                  return a.getOffsetParent == null ? void 0 : a.getOffsetParent(n);
                case 18:
                  R = _context2.sent;
                  O = R ? R[x] : 0;
                  _context2.t0 = O;
                  if (!_context2.t0) {
                    _context2.next = 25;
                    break;
                  }
                  _context2.next = 24;
                  return a.isElement == null ? void 0 : a.isElement(R);
                case 24:
                  _context2.t0 = _context2.sent;
                case 25:
                  _context2.t1 = _context2.t0;
                  if (_context2.t1) {
                    _context2.next = 28;
                    break;
                  }
                  O = u.floating[x] || s.floating[p];
                case 28:
                  q = b / 2 - _ / 2, W = f[w], N = O - y[p] - f[T], M = O / 2 - y[p] / 2 + q, v = ee(W, M, N), P = _t(i) != null && M != v && s.reference[p] / 2 - (M < W ? f[w] : f[T]) - y[p] / 2 < 0;
                  return _context2.abrupt("return", (_ref6 = {}, _defineProperty(_ref6, d, c[d] - (P ? M < W ? W - M : N - M : 0)), _defineProperty(_ref6, "data", (_data = {}, _defineProperty(_data, d, v), _defineProperty(_data, "centerOffset", M - v), _data)), _ref6));
                case 30:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    };
  },
  go = ["top", "right", "bottom", "left"],
  Go = go.reduce(function (t, e) {
    return t.concat(e, e + "-start", e + "-end");
  }, []),
  wo = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };
function Vt(t) {
  return t.replace(/left|right|bottom|top/g, function (e) {
    return wo[e];
  });
}
function To(t, e, n) {
  n === void 0 && (n = !1);
  var o = _t(t),
    l = St(t),
    r = oe(l),
    i = l === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (i = Vt(i)), {
    main: i,
    cross: Vt(i)
  };
}
var xo = {
  start: "end",
  end: "start"
};
function te(t) {
  return t.replace(/start|end/g, function (e) {
    return xo[e];
  });
}
var ie = function ie(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    fn: function fn(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var n, o, l, r, i, s, a, _t2, _t2$mainAxis, u, _t2$crossAxis, f, c, _t2$fallbackStrategy, d, _t2$fallbackAxisSideD, p, _t2$flipAlignment, y, g, w, T, x, b, _, R, O, q, _To, v, P, W, N, _v, _P, D, M, B;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                o = e.placement;
                l = e.middlewareData;
                r = e.rects;
                i = e.initialPlacement;
                s = e.platform;
                a = e.elements;
                _t2 = t;
                _t2$mainAxis = _t2.mainAxis;
                u = _t2$mainAxis === void 0 ? !0 : _t2$mainAxis;
                _t2$crossAxis = _t2.crossAxis;
                f = _t2$crossAxis === void 0 ? !0 : _t2$crossAxis;
                c = _t2.fallbackPlacements;
                _t2$fallbackStrategy = _t2.fallbackStrategy;
                d = _t2$fallbackStrategy === void 0 ? "bestFit" : _t2$fallbackStrategy;
                _t2$fallbackAxisSideD = _t2.fallbackAxisSideDirection;
                p = _t2$fallbackAxisSideD === void 0 ? "none" : _t2$fallbackAxisSideD;
                _t2$flipAlignment = _t2.flipAlignment;
                y = _t2$flipAlignment === void 0 ? !0 : _t2$flipAlignment;
                g = _objectWithoutProperties(_t2, _excluded);
                w = dt(o);
                T = dt(i) === i;
                _context3.next = 23;
                return s.isRTL == null ? void 0 : s.isRTL(a.floating);
              case 23:
                x = _context3.sent;
                b = c || (T || !y ? [Vt(i)] : function (v) {
                  var P = Vt(v);
                  return [te(v), P, te(P)];
                }(i));
                c || p === "none" || b.push.apply(b, _toConsumableArray(function (v, P, D, B) {
                  var S = _t(v),
                    A = function (J, tt, mt) {
                      var ct = ["left", "right"],
                        ht = ["right", "left"],
                        yt = ["top", "bottom"],
                        K = ["bottom", "top"];
                      switch (J) {
                        case "top":
                        case "bottom":
                          return mt ? tt ? ht : ct : tt ? ct : ht;
                        case "left":
                        case "right":
                          return tt ? yt : K;
                        default:
                          return [];
                      }
                    }(dt(v), D === "start", B);
                  return S && (A = A.map(function (J) {
                    return J + "-" + S;
                  }), P && (A = A.concat(A.map(te)))), A;
                }(i, y, p, x)));
                _ = [i].concat(_toConsumableArray(b));
                _context3.next = 29;
                return ne(e, g);
              case 29:
                R = _context3.sent;
                O = [];
                q = ((n = l.flip) == null ? void 0 : n.overflows) || [];
                if (u && O.push(R[w]), f) {
                  _To = To(o, r, x), v = _To.main, P = _To.cross;
                  O.push(R[v], R[P]);
                }
                if (!(q = [].concat(_toConsumableArray(q), [{
                  placement: o,
                  overflows: O
                }]), !O.every(function (v) {
                  return v <= 0;
                }))) {
                  _context3.next = 48;
                  break;
                }
                _v = (((W = l.flip) == null ? void 0 : W.index) || 0) + 1, _P = _[_v];
                if (!_P) {
                  _context3.next = 37;
                  break;
                }
                return _context3.abrupt("return", {
                  data: {
                    index: _v,
                    overflows: q
                  },
                  reset: {
                    placement: _P
                  }
                });
              case 37:
                D = (N = q.filter(function (B) {
                  return B.overflows[0] <= 0;
                }).sort(function (B, S) {
                  return B.overflows[1] - S.overflows[1];
                })[0]) == null ? void 0 : N.placement;
                if (D) {
                  _context3.next = 46;
                  break;
                }
                _context3.t0 = d;
                _context3.next = _context3.t0 === "bestFit" ? 42 : _context3.t0 === "initialPlacement" ? 45 : 46;
                break;
              case 42:
                B = (M = q.map(function (S) {
                  return [S.placement, S.overflows.filter(function (A) {
                    return A > 0;
                  }).reduce(function (A, J) {
                    return A + J;
                  }, 0)];
                }).sort(function (S, A) {
                  return S[1] - A[1];
                })[0]) == null ? void 0 : M[0];
                B && (D = B);
                return _context3.abrupt("break", 46);
              case 45:
                D = i;
              case 46:
                if (!(o !== D)) {
                  _context3.next = 48;
                  break;
                }
                return _context3.abrupt("return", {
                  reset: {
                    placement: D
                  }
                });
              case 48:
                return _context3.abrupt("return", {});
              case 49:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
};
var le = function le(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    fn: function fn(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var n, o, l;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                n = e.x;
                o = e.y;
                _context5.next = 4;
                return function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(r, i) {
                    var s, a, u, f, c, d, p, y, g, w, _ref8, T, x, b;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            s = r.placement;
                            a = r.platform;
                            u = r.elements;
                            _context4.next = 5;
                            return a.isRTL == null ? void 0 : a.isRTL(u.floating);
                          case 5:
                            f = _context4.sent;
                            c = dt(s);
                            d = _t(s);
                            p = St(s) === "x";
                            y = ["left", "top"].includes(c) ? -1 : 1;
                            g = f && p ? -1 : 1;
                            w = typeof i == "function" ? i(r) : i;
                            _ref8 = typeof w == "number" ? {
                              mainAxis: w,
                              crossAxis: 0,
                              alignmentAxis: null
                            } : _objectSpread({
                              mainAxis: 0,
                              crossAxis: 0,
                              alignmentAxis: null
                            }, w);
                            T = _ref8.mainAxis;
                            x = _ref8.crossAxis;
                            b = _ref8.alignmentAxis;
                            return _context4.abrupt("return", (d && typeof b == "number" && (x = d === "end" ? -1 * b : b), p ? {
                              x: x * g,
                              y: T * y
                            } : {
                              x: T * y,
                              y: x * g
                            }));
                          case 17:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));
                  return function (_x6, _x7) {
                    return _ref7.apply(this, arguments);
                  };
                }()(e, t);
              case 4:
                l = _context5.sent;
                return _context5.abrupt("return", {
                  x: n + l.x,
                  y: o + l.y,
                  data: l
                });
              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  };
};
function vo(t) {
  return t === "x" ? "y" : "x";
}
var se = function se(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    fn: function fn(e) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _objectSpread5;
        var n, o, l, _t3, _t3$mainAxis, r, _t3$crossAxis, i, _t3$limiter, s, a, u, f, c, d, p, y, w, _w, g;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                n = e.x;
                o = e.y;
                l = e.placement;
                _t3 = t;
                _t3$mainAxis = _t3.mainAxis;
                r = _t3$mainAxis === void 0 ? !0 : _t3$mainAxis;
                _t3$crossAxis = _t3.crossAxis;
                i = _t3$crossAxis === void 0 ? !1 : _t3$crossAxis;
                _t3$limiter = _t3.limiter;
                s = _t3$limiter === void 0 ? {
                  fn: function fn(w) {
                    var T = w.x,
                      x = w.y;
                    return {
                      x: T,
                      y: x
                    };
                  }
                } : _t3$limiter;
                a = _objectWithoutProperties(_t3, _excluded2);
                u = {
                  x: n,
                  y: o
                };
                _context6.next = 14;
                return ne(e, a);
              case 14:
                f = _context6.sent;
                c = St(dt(l));
                d = vo(c);
                p = u[c];
                y = u[d];
                if (r) {
                  w = c === "y" ? "bottom" : "right";
                  p = ee(p + f[c === "y" ? "top" : "left"], p, p - f[w]);
                }
                if (i) {
                  _w = d === "y" ? "bottom" : "right";
                  y = ee(y + f[d === "y" ? "top" : "left"], y, y - f[_w]);
                }
                g = s.fn(_objectSpread(_objectSpread({}, e), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, c, p), _defineProperty(_objectSpread5, d, y), _objectSpread5)));
                return _context6.abrupt("return", _objectSpread(_objectSpread({}, g), {}, {
                  data: {
                    x: g.x - n,
                    y: g.y - o
                  }
                }));
              case 23:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  };
};
function F(t) {
  var e;
  return ((e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Y(t) {
  return F(t).getComputedStyle(t);
}
var Re = Math.min,
  Pt = Math.max,
  $t = Math.round;
function ke(t) {
  var e = Y(t),
    n = parseFloat(e.width),
    o = parseFloat(e.height),
    l = t.offsetWidth,
    r = t.offsetHeight,
    i = $t(n) !== l || $t(o) !== r;
  return i && (n = l, o = r), {
    width: n,
    height: o,
    fallback: i
  };
}
function it(t) {
  return Me(t) ? (t.nodeName || "").toLowerCase() : "";
}
var It;
function De() {
  if (It) return It;
  var t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? (It = t.brands.map(function (e) {
    return e.brand + "/" + e.version;
  }).join(" "), It) : navigator.userAgent;
}
function z(t) {
  return t instanceof F(t).HTMLElement;
}
function nt(t) {
  return t instanceof F(t).Element;
}
function Me(t) {
  return t instanceof F(t).Node;
}
function _e(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof F(t).ShadowRoot || t instanceof ShadowRoot;
}
function zt(t) {
  var _Y = Y(t),
    e = _Y.overflow,
    n = _Y.overflowX,
    o = _Y.overflowY,
    l = _Y.display;
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(l);
}
function bo(t) {
  return ["table", "td", "th"].includes(it(t));
}
function ce(t) {
  var e = /firefox/i.test(De()),
    n = Y(t),
    o = n.backdropFilter || n.WebkitBackdropFilter;
  return n.transform !== "none" || n.perspective !== "none" || !!o && o !== "none" || e && n.willChange === "filter" || e && !!n.filter && n.filter !== "none" || ["transform", "perspective"].some(function (l) {
    return n.willChange.includes(l);
  }) || ["paint", "layout", "strict", "content"].some(function (l) {
    var r = n.contain;
    return r != null && r.includes(l);
  });
}
function ae() {
  return /^((?!chrome|android).)*safari/i.test(De());
}
function fe(t) {
  return ["html", "body", "#document"].includes(it(t));
}
function He(t) {
  return nt(t) ? t : t.contextElement;
}
var Oe = {
  x: 1,
  y: 1
};
function Tt(t) {
  var e = He(t);
  if (!z(e)) return Oe;
  var n = e.getBoundingClientRect(),
    _ke = ke(e),
    o = _ke.width,
    l = _ke.height,
    r = _ke.fallback,
    i = (r ? $t(n.width) : n.width) / o,
    s = (r ? $t(n.height) : n.height) / l;
  return i && Number.isFinite(i) || (i = 1), s && Number.isFinite(s) || (s = 1), {
    x: i,
    y: s
  };
}
function Ct(t, e, n, o) {
  var l, r;
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var i = t.getBoundingClientRect(),
    s = He(t),
    a = Oe;
  e && (o ? nt(o) && (a = Tt(o)) : a = Tt(t));
  var u = s ? F(s) : window,
    f = ae() && n,
    c = (i.left + (f && ((l = u.visualViewport) == null ? void 0 : l.offsetLeft) || 0)) / a.x,
    d = (i.top + (f && ((r = u.visualViewport) == null ? void 0 : r.offsetTop) || 0)) / a.y,
    p = i.width / a.x,
    y = i.height / a.y;
  if (s) {
    var g = F(s),
      w = o && nt(o) ? F(o) : o,
      T = g.frameElement;
    for (; T && o && w !== g;) {
      var x = Tt(T),
        b = T.getBoundingClientRect(),
        _ = getComputedStyle(T);
      b.x += (T.clientLeft + parseFloat(_.paddingLeft)) * x.x, b.y += (T.clientTop + parseFloat(_.paddingTop)) * x.y, c *= x.x, d *= x.y, p *= x.x, y *= x.y, c += b.x, d += b.y, T = F(T).frameElement;
    }
  }
  return Rt({
    width: p,
    height: y,
    x: c,
    y: d
  });
}
function rt(t) {
  return ((Me(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function jt(t) {
  return nt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Be(t) {
  return Ct(rt(t)).left + jt(t).scrollLeft;
}
function kt(t) {
  if (it(t) === "html") return t;
  var e = t.assignedSlot || t.parentNode || _e(t) && t.host || rt(t);
  return _e(e) ? e.host : e;
}
function We(t) {
  var e = kt(t);
  return fe(e) ? e.ownerDocument.body : z(e) && zt(e) ? e : We(e);
}
function qe(t, e) {
  var n;
  e === void 0 && (e = []);
  var o = We(t),
    l = o === ((n = t.ownerDocument) == null ? void 0 : n.body),
    r = F(o);
  return l ? e.concat(r, r.visualViewport || [], zt(o) ? o : []) : e.concat(o, qe(o));
}
function Se(t, e, n) {
  var o;
  if (e === "viewport") o = function (i, s) {
    var a = F(i),
      u = rt(i),
      f = a.visualViewport,
      c = u.clientWidth,
      d = u.clientHeight,
      p = 0,
      y = 0;
    if (f) {
      c = f.width, d = f.height;
      var g = ae();
      (!g || g && s === "fixed") && (p = f.offsetLeft, y = f.offsetTop);
    }
    return {
      width: c,
      height: d,
      x: p,
      y: y
    };
  }(t, n);else if (e === "document") o = function (i) {
    var s = rt(i),
      a = jt(i),
      u = i.ownerDocument.body,
      f = Pt(s.scrollWidth, s.clientWidth, u.scrollWidth, u.clientWidth),
      c = Pt(s.scrollHeight, s.clientHeight, u.scrollHeight, u.clientHeight),
      d = -a.scrollLeft + Be(i),
      p = -a.scrollTop;
    return Y(u).direction === "rtl" && (d += Pt(s.clientWidth, u.clientWidth) - f), {
      width: f,
      height: c,
      x: d,
      y: p
    };
  }(rt(t));else if (nt(e)) o = function (i, s) {
    var a = Ct(i, !0, s === "fixed"),
      u = a.top + i.clientTop,
      f = a.left + i.clientLeft,
      c = z(i) ? Tt(i) : {
        x: 1,
        y: 1
      };
    return {
      width: i.clientWidth * c.x,
      height: i.clientHeight * c.y,
      x: f * c.x,
      y: u * c.y
    };
  }(e, n);else {
    var i = _objectSpread({}, e);
    if (ae()) {
      var l, r;
      var s = F(t);
      i.x -= ((l = s.visualViewport) == null ? void 0 : l.offsetLeft) || 0, i.y -= ((r = s.visualViewport) == null ? void 0 : r.offsetTop) || 0;
    }
    o = i;
  }
  return Rt(o);
}
function Pe(t, e) {
  return z(t) && Y(t).position !== "fixed" ? e ? e(t) : t.offsetParent : null;
}
function Ce(t, e) {
  var n = F(t);
  if (!z(t)) return n;
  var o = Pe(t, e);
  for (; o && bo(o) && Y(o).position === "static";) {
    o = Pe(o, e);
  }
  return o && (it(o) === "html" || it(o) === "body" && Y(o).position === "static" && !ce(o)) ? n : o || function (l) {
    var r = kt(l);
    for (; z(r) && !fe(r);) {
      if (ce(r)) return r;
      r = kt(r);
    }
    return null;
  }(t) || n;
}
function Eo(t, e, n) {
  var o = z(e),
    l = rt(e),
    r = Ct(t, !0, n === "fixed", e),
    i = {
      scrollLeft: 0,
      scrollTop: 0
    },
    s = {
      x: 0,
      y: 0
    };
  if (o || !o && n !== "fixed") if ((it(e) !== "body" || zt(l)) && (i = jt(e)), z(e)) {
    var a = Ct(e, !0);
    s.x = a.x + e.clientLeft, s.y = a.y + e.clientTop;
  } else l && (s.x = Be(l));
  return {
    x: r.left + i.scrollLeft - s.x,
    y: r.top + i.scrollTop - s.y,
    width: r.width,
    height: r.height
  };
}
var Ao = {
  getClippingRect: function getClippingRect(t) {
    var e = t.element,
      n = t.boundary,
      o = t.rootBoundary,
      l = t.strategy,
      r = n === "clippingAncestors" ? function (u, f) {
        var c = f.get(u);
        if (c) return c;
        var d = qe(u).filter(function (w) {
            return nt(w) && it(w) !== "body";
          }),
          p = null,
          y = Y(u).position === "fixed",
          g = y ? kt(u) : u;
        for (; nt(g) && !fe(g);) {
          var w = Y(g),
            T = ce(g);
          w.position === "fixed" ? p = null : (y ? T || p : T || w.position !== "static" || !p || !["absolute", "fixed"].includes(p.position)) ? p = w : d = d.filter(function (x) {
            return x !== g;
          }), g = kt(g);
        }
        return f.set(u, d), d;
      }(e, this._c) : [].concat(n),
      i = [].concat(_toConsumableArray(r), [o]),
      s = i[0],
      a = i.reduce(function (u, f) {
        var c = Se(e, f, l);
        return u.top = Pt(c.top, u.top), u.right = Re(c.right, u.right), u.bottom = Re(c.bottom, u.bottom), u.left = Pt(c.left, u.left), u;
      }, Se(e, s, l));
    return {
      width: a.right - a.left,
      height: a.bottom - a.top,
      x: a.left,
      y: a.top
    };
  },
  convertOffsetParentRelativeRectToViewportRelativeRect: function convertOffsetParentRelativeRectToViewportRelativeRect(t) {
    var e = t.rect,
      n = t.offsetParent,
      o = t.strategy,
      l = z(n),
      r = rt(n);
    if (n === r) return e;
    var i = {
        scrollLeft: 0,
        scrollTop: 0
      },
      s = {
        x: 1,
        y: 1
      },
      a = {
        x: 0,
        y: 0
      };
    if ((l || !l && o !== "fixed") && ((it(n) !== "body" || zt(r)) && (i = jt(n)), z(n))) {
      var u = Ct(n);
      s = Tt(n), a.x = u.x + n.clientLeft, a.y = u.y + n.clientTop;
    }
    return {
      width: e.width * s.x,
      height: e.height * s.y,
      x: e.x * s.x - i.scrollLeft * s.x + a.x,
      y: e.y * s.y - i.scrollTop * s.y + a.y
    };
  },
  isElement: nt,
  getDimensions: function getDimensions(t) {
    return z(t) ? ke(t) : t.getBoundingClientRect();
  },
  getOffsetParent: Ce,
  getDocumentElement: rt,
  getScale: Tt,
  getElementRects: function getElementRects(t) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var e, n, o, l, r;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              e = t.reference, n = t.floating, o = t.strategy, l = _this2.getOffsetParent || Ce, r = _this2.getDimensions;
              _context7.t0 = Eo;
              _context7.t1 = e;
              _context7.next = 5;
              return l(n);
            case 5:
              _context7.t2 = _context7.sent;
              _context7.t3 = o;
              _context7.t4 = (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t3);
              _context7.t5 = _objectSpread;
              _context7.t6 = {
                x: 0,
                y: 0
              };
              _context7.next = 12;
              return r(n);
            case 12:
              _context7.t7 = _context7.sent;
              _context7.t8 = (0, _context7.t5)(_context7.t6, _context7.t7);
              return _context7.abrupt("return", {
                reference: _context7.t4,
                floating: _context7.t8
              });
            case 15:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  getClientRects: function getClientRects(t) {
    return Array.from(t.getClientRects());
  },
  isRTL: function isRTL(t) {
    return Y(t).direction === "rtl";
  }
};
var ue = function ue(t, e, n) {
  var o = new Map(),
    l = _objectSpread({
      platform: Ao
    }, n),
    r = _objectSpread(_objectSpread({}, l.platform), {}, {
      _c: o
    });
  return Ae(t, e, _objectSpread(_objectSpread({}, l), {}, {
    platform: r
  }));
};
var pe = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref9) {
    var _ref9$elementReferenc, t, _ref9$tooltipReferenc, e, _ref9$tooltipArrowRef, n, _ref9$place, o, _ref9$offset, l, _ref9$strategy, r, _ref9$middlewares, i, s;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _ref9$elementReferenc = _ref9.elementReference, t = _ref9$elementReferenc === void 0 ? null : _ref9$elementReferenc, _ref9$tooltipReferenc = _ref9.tooltipReference, e = _ref9$tooltipReferenc === void 0 ? null : _ref9$tooltipReferenc, _ref9$tooltipArrowRef = _ref9.tooltipArrowReference, n = _ref9$tooltipArrowRef === void 0 ? null : _ref9$tooltipArrowRef, _ref9$place = _ref9.place, o = _ref9$place === void 0 ? "top" : _ref9$place, _ref9$offset = _ref9.offset, l = _ref9$offset === void 0 ? 10 : _ref9$offset, _ref9$strategy = _ref9.strategy, r = _ref9$strategy === void 0 ? "absolute" : _ref9$strategy, _ref9$middlewares = _ref9.middlewares, i = _ref9$middlewares === void 0 ? [le(Number(l)), ie(), se({
              padding: 5
            })] : _ref9$middlewares;
            if (t) {
              _context8.next = 3;
              break;
            }
            return _context8.abrupt("return", {
              tooltipStyles: {},
              tooltipArrowStyles: {},
              place: o
            });
          case 3:
            if (!(e === null)) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return", {
              tooltipStyles: {},
              tooltipArrowStyles: {},
              place: o
            });
          case 5:
            s = i;
            return _context8.abrupt("return", n ? (s.push(re({
              element: n,
              padding: 5
            })), ue(t, e, {
              placement: o,
              strategy: r,
              middleware: s
            }).then(function (_ref11) {
              var a = _ref11.x,
                u = _ref11.y,
                f = _ref11.placement,
                c = _ref11.middlewareData;
              var T, x;
              var d = {
                  left: "".concat(a, "px"),
                  top: "".concat(u, "px")
                },
                _ref12 = (T = c.arrow) != null ? T : {
                  x: 0,
                  y: 0
                },
                p = _ref12.x,
                y = _ref12.y,
                g = (x = {
                  top: "bottom",
                  right: "left",
                  bottom: "top",
                  left: "right"
                }[f.split("-")[0]]) != null ? x : "bottom",
                w = _defineProperty({
                  left: p != null ? "".concat(p, "px") : "",
                  top: y != null ? "".concat(y, "px") : "",
                  right: "",
                  bottom: ""
                }, g, "-4px");
              return {
                tooltipStyles: d,
                tooltipArrowStyles: w,
                place: f
              };
            })) : ue(t, e, {
              placement: "bottom",
              strategy: r,
              middleware: s
            }).then(function (_ref13) {
              var a = _ref13.x,
                u = _ref13.y,
                f = _ref13.placement;
              return {
                tooltipStyles: {
                  left: "".concat(a, "px"),
                  top: "".concat(u, "px")
                },
                tooltipArrowStyles: {},
                place: f
              };
            }));
          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return function pe(_x8) {
    return _ref10.apply(this, arguments);
  };
}();
var lt = {
  arrow: "react-tooltip__arrow_KtSkBq",
  clickable: "react-tooltip__clickable_KtSkBq",
  dark: "react-tooltip__dark_KtSkBq",
  error: "react-tooltip__error_KtSkBq",
  fixed: "react-tooltip__fixed_KtSkBq",
  info: "react-tooltip__info_KtSkBq",
  light: "react-tooltip__light_KtSkBq",
  noArrow: "react-tooltip__no-arrow_KtSkBq",
  show: "react-tooltip__show_KtSkBq",
  success: "react-tooltip__success_KtSkBq",
  tooltip: "react-tooltip__tooltip_KtSkBq",
  warning: "react-tooltip__warning_KtSkBq"
};
import { jsx as Ne, jsxs as Ro } from "react/jsx-runtime";
var Lo = function Lo(_ref14) {
    var _ref18;
    var t = _ref14.id,
      e = _ref14.className,
      n = _ref14.classNameArrow,
      _ref14$variant = _ref14.variant,
      o = _ref14$variant === void 0 ? "dark" : _ref14$variant,
      l = _ref14.anchorId,
      r = _ref14.anchorSelect,
      _ref14$place = _ref14.place,
      i = _ref14$place === void 0 ? "top" : _ref14$place,
      _ref14$offset = _ref14.offset,
      s = _ref14$offset === void 0 ? 10 : _ref14$offset,
      _ref14$events = _ref14.events,
      a = _ref14$events === void 0 ? ["hover"] : _ref14$events,
      _ref14$positionStrate = _ref14.positionStrategy,
      u = _ref14$positionStrate === void 0 ? "absolute" : _ref14$positionStrate,
      f = _ref14.middlewares,
      c = _ref14.wrapper,
      _ref14$children = _ref14.children,
      d = _ref14$children === void 0 ? null : _ref14$children,
      _ref14$delayShow = _ref14.delayShow,
      p = _ref14$delayShow === void 0 ? 0 : _ref14$delayShow,
      _ref14$delayHide = _ref14.delayHide,
      y = _ref14$delayHide === void 0 ? 0 : _ref14$delayHide,
      _ref14$float = _ref14.float,
      g = _ref14$float === void 0 ? !1 : _ref14$float,
      _ref14$noArrow = _ref14.noArrow,
      w = _ref14$noArrow === void 0 ? !1 : _ref14$noArrow,
      _ref14$clickable = _ref14.clickable,
      T = _ref14$clickable === void 0 ? !1 : _ref14$clickable,
      _ref14$closeOnEsc = _ref14.closeOnEsc,
      x = _ref14$closeOnEsc === void 0 ? !1 : _ref14$closeOnEsc,
      b = _ref14.style,
      _ = _ref14.position,
      R = _ref14.afterShow,
      O = _ref14.afterHide,
      q = _ref14.content,
      W = _ref14.html,
      N = _ref14.isOpen,
      M = _ref14.setIsOpen,
      v = _ref14.activeAnchor,
      P = _ref14.setActiveAnchor;
    var D = st(null),
      B = st(null),
      S = st(null),
      A = st(null),
      _xt = xt(i),
      _xt2 = _slicedToArray(_xt, 2),
      J = _xt2[0],
      tt = _xt2[1],
      _xt3 = xt({}),
      _xt4 = _slicedToArray(_xt3, 2),
      mt = _xt4[0],
      ct = _xt4[1],
      _xt5 = xt({}),
      _xt6 = _slicedToArray(_xt5, 2),
      ht = _xt6[0],
      yt = _xt6[1],
      _xt7 = xt(!1),
      _xt8 = _slicedToArray(_xt7, 2),
      K = _xt8[0],
      Dt = _xt8[1],
      _xt9 = xt(!1),
      _xt10 = _slicedToArray(_xt9, 2),
      Mt = _xt10[0],
      gt = _xt10[1],
      Ht = st(!1),
      vt = st(null),
      _pt2 = pt(t),
      Ot = _pt2.anchorRefs,
      Yt = _pt2.setActiveAnchor,
      bt = st(!1),
      _xt11 = xt([]),
      _xt12 = _slicedToArray(_xt11, 2),
      et = _xt12[0],
      G = _xt12[1],
      at = st(!1);
    be(function () {
      return at.current = !0, function () {
        at.current = !1;
      };
    }, []), Z(function () {
      if (!K) {
        var m = setTimeout(function () {
          gt(!1);
        }, 150);
        return function () {
          clearTimeout(m);
        };
      }
      return function () {
        return null;
      };
    }, [K]);
    var j = function j(m) {
      at.current && (m && gt(!0), setTimeout(function () {
        at.current && (M == null || M(m), N === void 0 && Dt(m));
      }, 10));
    };
    Z(function () {
      if (N === void 0) return function () {
        return null;
      };
      N && gt(!0);
      var m = setTimeout(function () {
        Dt(N);
      }, 10);
      return function () {
        clearTimeout(m);
      };
    }, [N]), Z(function () {
      K !== Ht.current && (Ht.current = K, K ? R == null || R() : O == null || O());
    }, [K]);
    var Bt = function Bt() {
        S.current && clearTimeout(S.current), S.current = setTimeout(function () {
          j(!0);
        }, p);
      },
      wt = function wt() {
        var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : y;
        A.current && clearTimeout(A.current), A.current = setTimeout(function () {
          bt.current || j(!1);
        }, m);
      },
      Et = function Et(m) {
        var L;
        if (!m) return;
        p ? Bt() : j(!0);
        var E = (L = m.currentTarget) != null ? L : m.target;
        P(E), Yt({
          current: E
        }), A.current && clearTimeout(A.current);
      },
      At = function At() {
        T ? wt(y || 100) : y ? wt() : j(!1), S.current && clearTimeout(S.current);
      },
      C = function C(_ref15) {
        var m = _ref15.x,
          E = _ref15.y;
        pe({
          place: i,
          offset: s,
          elementReference: {
            getBoundingClientRect: function getBoundingClientRect() {
              return {
                x: m,
                y: E,
                width: 0,
                height: 0,
                top: E,
                left: m,
                right: m,
                bottom: E
              };
            }
          },
          tooltipReference: D.current,
          tooltipArrowReference: B.current,
          strategy: u,
          middlewares: f
        }).then(function (U) {
          Object.keys(U.tooltipStyles).length && ct(U.tooltipStyles), Object.keys(U.tooltipArrowStyles).length && yt(U.tooltipArrowStyles), tt(U.place);
        });
      },
      V = function V(m) {
        if (!m) return;
        var E = m,
          L = {
            x: E.clientX,
            y: E.clientY
          };
        C(L), vt.current = L;
      },
      h = function h(m) {
        Et(m), y && wt();
      },
      k = function k(m) {
        var E = document.querySelector("[id='".concat(l, "']"));
        E != null && E.contains(m.target) || et.some(function (L) {
          return L.contains(m.target);
        }) || j(!1);
      },
      X = function X(m) {
        m.key === "Escape" && j(!1);
      },
      ft = Qt(Et, 50),
      Wt = Qt(At, 50);
    Z(function () {
      var I, Q;
      var m = new Set(Ot);
      et.forEach(function (H) {
        m.add({
          current: H
        });
      });
      var E = document.querySelector("[id='".concat(l, "']"));
      E && m.add({
        current: E
      }), x && window.addEventListener("keydown", X);
      var L = [];
      a.find(function (H) {
        return H === "click";
      }) && (window.addEventListener("click", k), L.push({
        event: "click",
        listener: h
      })), a.find(function (H) {
        return H === "hover";
      }) && (L.push({
        event: "mouseenter",
        listener: ft
      }, {
        event: "mouseleave",
        listener: Wt
      }, {
        event: "focus",
        listener: ft
      }, {
        event: "blur",
        listener: Wt
      }), g && L.push({
        event: "mousemove",
        listener: V
      }));
      var U = function U() {
          bt.current = !0;
        },
        ot = function ot() {
          bt.current = !1, At();
        };
      return T && ((I = D.current) == null || I.addEventListener("mouseenter", U), (Q = D.current) == null || Q.addEventListener("mouseleave", ot)), L.forEach(function (_ref16) {
        var H = _ref16.event,
          qt = _ref16.listener;
        m.forEach(function (Lt) {
          var Nt;
          (Nt = Lt.current) == null || Nt.addEventListener(H, qt);
        });
      }), function () {
        var H, qt;
        a.find(function (Lt) {
          return Lt === "click";
        }) && window.removeEventListener("click", k), x && window.removeEventListener("keydown", X), T && ((H = D.current) == null || H.removeEventListener("mouseenter", U), (qt = D.current) == null || qt.removeEventListener("mouseleave", ot)), L.forEach(function (_ref17) {
          var Lt = _ref17.event,
            Nt = _ref17.listener;
          m.forEach(function (Ve) {
            var me;
            (me = Ve.current) == null || me.removeEventListener(Lt, Nt);
          });
        });
      };
    }, [Mt, Ot, et, x, a]), Z(function () {
      var m = r != null ? r : "";
      !m && t && (m = "[data-tooltip-id='".concat(t, "']"));
      var E = function E(U) {
          var ot = [];
          U.forEach(function (I) {
            if (I.type === "attributes" && I.attributeName === "data-tooltip-id" && I.target.getAttribute("data-tooltip-id") === t && ot.push(I.target), I.type === "childList" && (v && _toConsumableArray(I.removedNodes).some(function (Q) {
              return Q.contains(v) ? (gt(!1), j(!1), P(null), !0) : !1;
            }), !!m)) try {
              var Q = _toConsumableArray(I.addedNodes).filter(function (H) {
                return H.nodeType === 1;
              });
              ot.push.apply(ot, _toConsumableArray(Q.filter(function (H) {
                return H.matches(m);
              }))), ot.push.apply(ot, _toConsumableArray(Q.flatMap(function (H) {
                return _toConsumableArray(H.querySelectorAll(m));
              })));
            } catch (Q) {}
          }), ot.length && G(function (I) {
            return [].concat(_toConsumableArray(I), ot);
          });
        },
        L = new MutationObserver(E);
      return L.observe(document.body, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-tooltip-id"]
      }), function () {
        L.disconnect();
      };
    }, [t, r, v]), Z(function () {
      if (_) {
        C(_);
        return;
      }
      if (g) {
        vt.current && C(vt.current);
        return;
      }
      pe({
        place: i,
        offset: s,
        elementReference: v,
        tooltipReference: D.current,
        tooltipArrowReference: B.current,
        strategy: u,
        middlewares: f
      }).then(function (m) {
        at.current && (Object.keys(m.tooltipStyles).length && ct(m.tooltipStyles), Object.keys(m.tooltipArrowStyles).length && yt(m.tooltipArrowStyles), tt(m.place));
      });
    }, [K, v, q, W, i, s, u, _]), Z(function () {
      var L;
      var m = document.querySelector("[id='".concat(l, "']")),
        E = [].concat(_toConsumableArray(et), [m]);
      (!v || !E.includes(v)) && P((L = et[0]) != null ? L : m);
    }, [l, et, v]), Z(function () {
      return function () {
        S.current && clearTimeout(S.current), A.current && clearTimeout(A.current);
      };
    }, []), Z(function () {
      var m = r;
      if (!m && t && (m = "[data-tooltip-id='".concat(t, "']")), !!m) try {
        var E = Array.from(document.querySelectorAll(m));
        G(E);
      } catch (E) {
        G([]);
      }
    }, [t, r]);
    var ut = !!(W || q || d) && K && Object.keys(mt).length > 0;
    return Mt ? Ro(c, {
      id: t,
      role: "tooltip",
      className: (0, de.default)("react-tooltip", lt.tooltip, lt[o], e, "react-tooltip__place-".concat(J), (_ref18 = {}, _defineProperty(_ref18, lt.show, ut), _defineProperty(_ref18, lt.fixed, u === "fixed"), _defineProperty(_ref18, lt.clickable, T), _ref18)),
      style: _objectSpread(_objectSpread({}, b), mt),
      ref: D,
      children: [W && Ne(Zt, {
        content: W
      }) || q || d, Ne(c, {
        className: (0, de.default)("react-tooltip-arrow", lt.arrow, n, _defineProperty({}, lt.noArrow, w)),
        style: ht,
        ref: B
      })]
    }) : null;
  },
  Xt = Lo;
import { jsx as Fe } from "react/jsx-runtime";
var _o = function _o(_ref20) {
    var t = _ref20.id,
      e = _ref20.anchorId,
      n = _ref20.anchorSelect,
      o = _ref20.content,
      l = _ref20.html,
      r = _ref20.className,
      i = _ref20.classNameArrow,
      _ref20$variant = _ref20.variant,
      s = _ref20$variant === void 0 ? "dark" : _ref20$variant,
      _ref20$place = _ref20.place,
      a = _ref20$place === void 0 ? "top" : _ref20$place,
      _ref20$offset = _ref20.offset,
      u = _ref20$offset === void 0 ? 10 : _ref20$offset,
      _ref20$wrapper = _ref20.wrapper,
      f = _ref20$wrapper === void 0 ? "div" : _ref20$wrapper,
      _ref20$children = _ref20.children,
      c = _ref20$children === void 0 ? null : _ref20$children,
      _ref20$events = _ref20.events,
      d = _ref20$events === void 0 ? ["hover"] : _ref20$events,
      _ref20$positionStrate = _ref20.positionStrategy,
      p = _ref20$positionStrate === void 0 ? "absolute" : _ref20$positionStrate,
      y = _ref20.middlewares,
      _ref20$delayShow = _ref20.delayShow,
      g = _ref20$delayShow === void 0 ? 0 : _ref20$delayShow,
      _ref20$delayHide = _ref20.delayHide,
      w = _ref20$delayHide === void 0 ? 0 : _ref20$delayHide,
      _ref20$float = _ref20.float,
      T = _ref20$float === void 0 ? !1 : _ref20$float,
      _ref20$noArrow = _ref20.noArrow,
      x = _ref20$noArrow === void 0 ? !1 : _ref20$noArrow,
      _ref20$clickable = _ref20.clickable,
      b = _ref20$clickable === void 0 ? !1 : _ref20$clickable,
      _ref20$closeOnEsc = _ref20.closeOnEsc,
      _ = _ref20$closeOnEsc === void 0 ? !1 : _ref20$closeOnEsc,
      R = _ref20.style,
      O = _ref20.position,
      q = _ref20.isOpen,
      W = _ref20.setIsOpen,
      N = _ref20.afterShow,
      M = _ref20.afterHide;
    var _$ = $(o),
      _$2 = _slicedToArray(_$, 2),
      v = _$2[0],
      P = _$2[1],
      _$3 = $(l),
      _$4 = _slicedToArray(_$3, 2),
      D = _$4[0],
      B = _$4[1],
      _$5 = $(a),
      _$6 = _slicedToArray(_$5, 2),
      S = _$6[0],
      A = _$6[1],
      _$7 = $(s),
      _$8 = _slicedToArray(_$7, 2),
      J = _$8[0],
      tt = _$8[1],
      _$9 = $(u),
      _$10 = _slicedToArray(_$9, 2),
      mt = _$10[0],
      ct = _$10[1],
      _$11 = $(g),
      _$12 = _slicedToArray(_$11, 2),
      ht = _$12[0],
      yt = _$12[1],
      _$13 = $(w),
      _$14 = _slicedToArray(_$13, 2),
      K = _$14[0],
      Dt = _$14[1],
      _$15 = $(T),
      _$16 = _slicedToArray(_$15, 2),
      Mt = _$16[0],
      gt = _$16[1],
      _$17 = $(f),
      _$18 = _slicedToArray(_$17, 2),
      Ht = _$18[0],
      vt = _$18[1],
      _$19 = $(d),
      _$20 = _slicedToArray(_$19, 2),
      Ot = _$20[0],
      Yt = _$20[1],
      _$21 = $(p),
      _$22 = _slicedToArray(_$21, 2),
      bt = _$22[0],
      et = _$22[1],
      _$23 = $(null),
      _$24 = _slicedToArray(_$23, 2),
      G = _$24[0],
      at = _$24[1],
      _pt3 = pt(t),
      j = _pt3.anchorRefs,
      Bt = _pt3.activeAnchor,
      wt = function wt(C) {
        return C == null ? void 0 : C.getAttributeNames().reduce(function (h, k) {
          var X;
          if (k.startsWith("data-tooltip-")) {
            var ft = k.replace(/^data-tooltip-/, "");
            h[ft] = (X = C == null ? void 0 : C.getAttribute(k)) != null ? X : null;
          }
          return h;
        }, {});
      },
      Et = function Et(C) {
        var V = {
          place: function place(h) {
            A(h != null ? h : a);
          },
          content: function content(h) {
            P(h != null ? h : o);
          },
          html: function html(h) {
            B(h != null ? h : l);
          },
          variant: function variant(h) {
            tt(h != null ? h : s);
          },
          offset: function offset(h) {
            ct(h === null ? u : Number(h));
          },
          wrapper: function wrapper(h) {
            vt(h != null ? h : f);
          },
          events: function events(h) {
            var k = h == null ? void 0 : h.split(" ");
            Yt(k != null ? k : d);
          },
          "position-strategy": function positionStrategy(h) {
            et(h != null ? h : p);
          },
          "delay-show": function delayShow(h) {
            yt(h === null ? g : Number(h));
          },
          "delay-hide": function delayHide(h) {
            Dt(h === null ? w : Number(h));
          },
          float: function float(h) {
            gt(h === null ? T : h === "true");
          }
        };
        Object.values(V).forEach(function (h) {
          return h(null);
        }), Object.entries(C).forEach(function (_ref21) {
          var _ref22 = _slicedToArray(_ref21, 2),
            h = _ref22[0],
            k = _ref22[1];
          var X;
          (X = V[h]) == null || X.call(V, k);
        });
      };
    Ut(function () {
      P(o);
    }, [o]), Ut(function () {
      B(l);
    }, [l]), Ut(function () {
      A(a);
    }, [a]), Ut(function () {
      var Jt;
      var C = new Set(j),
        V = n;
      if (!V && t && (V = "[data-tooltip-id='".concat(t, "']")), V) try {
        document.querySelectorAll(V).forEach(function (m) {
          C.add({
            current: m
          });
        });
      } catch (ut) {}
      var h = document.querySelector("[id='".concat(e, "']"));
      if (h && C.add({
        current: h
      }), !C.size) return function () {
        return null;
      };
      var k = (Jt = G != null ? G : h) != null ? Jt : Bt.current,
        X = function X(ut) {
          ut.forEach(function (m) {
            var L;
            if (!k || m.type !== "attributes" || !((L = m.attributeName) != null && L.startsWith("data-tooltip-"))) return;
            var E = wt(k);
            Et(E);
          });
        },
        ft = new MutationObserver(X),
        Wt = {
          attributes: !0,
          childList: !1,
          subtree: !1
        };
      if (k) {
        var ut = wt(k);
        Et(ut), ft.observe(k, Wt);
      }
      return function () {
        ft.disconnect();
      };
    }, [j, Bt, G, e, n]);
    var At = {
      id: t,
      anchorId: e,
      anchorSelect: n,
      className: r,
      classNameArrow: i,
      content: v,
      html: D,
      place: S,
      variant: J,
      offset: mt,
      wrapper: Ht,
      events: Ot,
      positionStrategy: bt,
      middlewares: y,
      delayShow: ht,
      delayHide: K,
      float: Mt,
      noArrow: x,
      clickable: b,
      closeOnEsc: _,
      style: R,
      position: O,
      isOpen: q,
      setIsOpen: W,
      afterShow: N,
      afterHide: M,
      activeAnchor: G,
      setActiveAnchor: function setActiveAnchor(C) {
        return at(C);
      }
    };
    return c ? Fe(Xt, _objectSpread(_objectSpread({}, At), {}, {
      children: c
    })) : Fe(Xt, _objectSpread({}, At));
  },
  Ke = _o;
export { Ke as Tooltip, Te as TooltipProvider, ve as TooltipWrapper };
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/